module.exports = __webpack_public_path__ + "assets/img/openinvest-get-started.09d65f59.webp";